import { createTheme } from '@mui/material'

export const defaultTheme = createTheme({
	palette: {
		primary: {
			main: '#3f51b5',
		},
	},
})
